
const Services = () => {
  const services = [
    {
      icon: 'ri-group-line',
      title: '马帮茶会',
      subtitle: '专属会员权益',
      description: '加入马帮茶会，享受专属会员价格、新品优先体验、专业茶艺指导等特权服务。',
      features: ['专属会员价格', '新品优先体验', '专业茶艺指导', '定期茶文化活动'],
      image: 'https://public.readdy.ai/ai/img_res/134404b90bc79ff0cd533294dcf61af9.jpg',
      bgColor: 'bg-[#3E3A39]',
      textColor: 'text-white',
      iconBg: 'bg-white/20',
      iconColor: 'text-[#E7BC71]',
      buttonColor: 'bg-[#E7BC71] hover:bg-[#E7BC71]/90 text-[#3E3A39]',
      checkColor: 'text-[#E7BC71]'
    },
    {
      icon: 'ri-home-line',
      title: '文化体验馆',
      subtitle: '沉浸式茶文化',
      description: '走进马帮瑞贡文化体验馆，亲身体验传统制茶工艺，感受三百年茶文化的深厚底蕴。',
      features: ['制茶工艺体验', '茶文化讲座', '古道历史展示', '专业品鉴指导'],
      image: 'https://static.readdy.ai/image/2e1ac11483faca2c19cd44d7d582b015/bc0774f02331c6b6ad4bb758f9a50724.jfif',
      bgColor: 'bg-[#603B28]',
      textColor: 'text-white',
      iconBg: 'bg-white/20',
      iconColor: 'text-[#E7BC71]',
      buttonColor: 'bg-[#E7BC71] hover:bg-[#E7BC71]/90 text-[#603B28]',
      checkColor: 'text-[#E7BC71]'
    },
    {
      icon: 'ri-qr-code-line',
      title: '数字化溯源',
      subtitle: '品质透明追踪',
      description: '每一款产品都配有独特的数字身份证，扫码即可了解茶叶的完整生产履历。',
      features: ['产地信息追踪', '制作工艺记录', '质检报告查询', '防伪验证系统'],
      image: 'https://readdy.ai/api/search-image?query=Digital%20traceability%20system%20for%20tea%20products%2C%20QR%20code%20scanning%2C%20modern%20technology%20interface%20showing%20tea%20origin%20and%20production%20process%2C%20transparent%20quality%20tracking%20display&width=400&height=300&seq=service3&orientation=landscape',
      bgColor: 'bg-[#E7BC71]',
      textColor: 'text-[#3E3A39]',
      iconBg: 'bg-[#3E3A39]/10',
      iconColor: 'text-[#603B28]',
      buttonColor: 'bg-[#603B28] hover:bg-[#603B28]/90 text-white',
      checkColor: 'text-[#603B28]'
    },
    {
      icon: 'ri-gift-line',
      title: '定制服务',
      subtitle: '个性化茶品',
      description: '提供企业定制、私人定制等个性化服务，打造专属于您的独特茶品。',
      features: ['企业定制服务', '私人专属配方', '个性化包装', '专业配送服务'],
      image: 'https://readdy.ai/api/search-image?query=Customized%20luxury%20tea%20gift%20packaging%20service%2C%20personalized%20tea%20products%2C%20bespoke%20packaging%20design%2C%20premium%20gift%20presentation%2C%20corporate%20customization%20display&width=400&height=300&seq=service4&orientation=landscape',
      bgColor: 'bg-slate-600',
      textColor: 'text-white',
      iconBg: 'bg-white/20',
      iconColor: 'text-[#E7BC71]',
      buttonColor: 'bg-[#E7BC71] hover:bg-[#E7BC71]/90 text-slate-600',
      checkColor: 'text-[#E7BC71]'
    }
  ];

  return (
    <section id="services" className="py-12 lg:py-16 bg-white">
      <div className="px-6 lg:px-16">
        <div className="text-center mb-8 lg:mb-12">
          <h2 className="text-2xl lg:text-3xl font-bold text-primary font-serif mb-3">
            服务与体验
          </h2>
          <p className="text-base text-gray-600 max-w-2xl mx-auto">
            不仅是茶品的提供者，更是茶文化的传播者，为您带来全方位的茶文化服务体验
          </p>
        </div>

        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 lg:gap-8">
            {services.map((service, index) => (
              <div
                key={index}
                className={`${service.bgColor} rounded-xl p-6 lg:p-8 hover:scale-105 transition-all duration-500 shadow-lg hover:shadow-2xl`}
              >
                <div className="flex flex-col space-y-4">
                  {/* Header */}
                  <div className="flex items-start space-x-3">
                    <div className={`w-12 h-12 ${service.iconBg} rounded-xl flex items-center justify-center flex-shrink-0`}>
                      <i className={`${service.icon} text-lg ${service.iconColor}`}></i>
                    </div>
                    <div className="flex-1">
                      <h3 className={`text-xl font-bold font-serif mb-1 ${service.textColor}`}>
                        {service.title}
                      </h3>
                      <p className={`text-base font-medium ${service.textColor === 'text-white' ? 'text-gray-200' : 'text-[#603B28]'}`}>
                        {service.subtitle}
                      </p>
                    </div>
                  </div>

                  {/* Image */}
                  <div className="rounded-lg overflow-hidden">
                    <img
                      src={service.image}
                      alt={service.title}
                      className="w-full h-40 object-cover object-top hover:scale-110 transition-transform duration-500"
                    />
                  </div>

                  {/* Description */}
                  <p className={`leading-relaxed text-sm ${service.textColor === 'text-white' ? 'text-gray-100' : 'text-gray-700'}`}>
                    {service.description}
                  </p>

                  {/* Features */}
                  <div className="grid grid-cols-2 gap-2">
                    {service.features.map((feature, idx) => (
                      <div key={idx} className="flex items-center space-x-1">
                        <i className={`ri-check-line ${service.checkColor} text-xs`}></i>
                        <span className={`text-xs ${service.textColor === 'text-white' ? 'text-gray-200' : 'text-gray-700'}`}>{feature}</span>
                      </div>
                    ))}
                  </div>

                  {/* CTA Button */}
                  <button className={`${service.buttonColor} px-4 py-2 rounded-full text-sm font-medium transition-all duration-300 hover:scale-105 cursor-pointer whitespace-nowrap self-start`}>
                    了解更多
                  </button>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Services;
